var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClaimSubmitP(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.285645,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#0C66E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18018 10.4648H9.77783C10.3364 10.4648 10.7544 10.3555 11.0317 10.1367C11.3091 9.91406 11.4478 9.5918 11.4478 9.16992C11.4478 8.74414 11.3306 8.42969 11.0962 8.22656C10.8657 8.02344 10.5024 7.92188 10.0063 7.92188H9.18018V10.4648ZM13.2817 9.10547C13.2817 10.0273 12.9927 10.7324 12.4146 11.2207C11.8403 11.709 11.022 11.9531 9.95947 11.9531H9.18018V15H7.36377V6.43359H10.1001C11.1392 6.43359 11.9282 6.6582 12.4673 7.10742C13.0103 7.55273 13.2817 8.21875 13.2817 9.10547Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimSubmitP);
export default __webpack_public_path__ + "static/media/claimSubmitP.10d6d05533fdd6368dbc7aa56459fefb.svg";
export { ForwardRef as ReactComponent };